import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29e7e00f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dropdown-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "search-wrap"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "option-checkbox"
}
const _hoisted_5 = {
  key: 1,
  class: "no-options"
}

import { Option, SelectDataManager } from '../types';
import { computed, nextTick, ref, watch } from 'vue';
import SingleLine from '@ui-kit/inputs/single-line/SingleLine.vue';
import Checkbox from '@ui-kit/inputs/checkbox/Checkbox.vue';

interface Props {
  dataManager: SelectDataManager,
  selectedIds?: any[];
  labelKey?: string,
  idKey?: string,
  height?: number,
  search?: boolean,
  searchPlaceholder?: string,
  deselectOptionText?: string,
  noOptionsText?: string,
  create?: boolean,
  multi?: boolean,
  showEmptyValue?: boolean;
}
interface Emits {
  (e: 'option-click', option: Option|undefined): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Dropdown',
  props: {
    dataManager: null,
    selectedIds: null,
    labelKey: { default: 'name' },
    idKey: { default: 'id' },
    height: { default: 200 },
    search: { type: Boolean },
    searchPlaceholder: null,
    deselectOptionText: null,
    noOptionsText: null,
    create: { type: Boolean },
    multi: { type: Boolean },
    showEmptyValue: { type: Boolean }
  },
  emits: ["option-click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'option-click', option: Option|undefined): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { dataManager: SelectDataManager, selectedIds?: any[], labelKey: string, idKey: string, height: number, search?: boolean, searchPlaceholder?: string, deselectOptionText?: string, noOptionsText?: string, create?: boolean, multi?: boolean, showEmptyValue?: boolean }





function onOptionClick(option?: Option) {
  emit('option-click', option);
}

const showSearch = computed(() => {
  return props.search || props.create;
})

const searchValue = computed(() => {
  return props.dataManager.searchValue.value;
});
function updateSearchValue(value: string) {
  props.dataManager.searchValue.value = value;
}
const options = ref<Option[]>([]);
const loading = ref<boolean>(false);
props.dataManager.searchValue.value = '';

function fetchNext() {
  if (loading.value) return;

  loading.value = true;
  return props.dataManager.fetchNextOptions().then((opts) => {
    options.value = opts;
  }).finally(() => {
    loading.value = false;
  })
}
fetchNext();
watch(searchValue, () => nextTick().then(() => fetchNext()));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(showSearch))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(SingleLine, {
            "model-value": _unref(searchValue),
            "onUpdate:modelValue": updateSearchValue,
            placeholder: __props.searchPlaceholder ? __props.searchPlaceholder : _ctx.$t('components.select.search'),
            flat: ""
          }, null, 8, ["model-value", "placeholder"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "options",
      style: _normalizeStyle(`max-height: ${__props.height}px`)
    }, [
      (__props.showEmptyValue)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "option option-empty",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (onOptionClick()))
          }, [
            _renderSlot(_ctx.$slots, "empty-option", {}, () => [
              _createTextVNode(_toDisplayString(__props.deselectOptionText ? __props.deselectOptionText : _ctx.$t('components.select.reset-option')), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option) => {
        return (_openBlock(), _createElementBlock("div", {
          key: option[__props.idKey],
          onClick: ($event: any) => (onOptionClick(option)),
          class: "option"
        }, [
          (__props.multi && __props.selectedIds)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(Checkbox, {
                  "model-value": __props.selectedIds.includes(option[__props.idKey])
                }, null, 8, ["model-value"])
              ]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "option", { option: option }, () => [
            _createElementVNode("span", null, _toDisplayString(option[__props.labelKey]), 1)
          ])
        ], 8, _hoisted_3))
      }), 128)),
      (options.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(__props.noOptionsText ? __props.noOptionsText : _ctx.$t('components.select.no-options')), 1))
        : _createCommentVNode("", true)
    ], 4)
  ]))
}
}

})